export const LOG_ARTIST_LOADING = "LOG_ARTIST_LOADING";
export const LOG_ARTIST_SUCCESS = "LOG_ARTIST_SUCCESS";
export const LOG_ARTIST_FAILURE = "LOG_ARTIST_FAILURE";

export const UPDATE_ARTIST_LOADING = "UPDATE_ARTIST_LOADING";
export const UPDATE_ARTIST_SUCCESS = "UPDATE_ARTIST_SUCCESS";
export const UPDATE_ARTIST_FAILURE = "UPDATE_ARTIST_FAILURE";

export const GET_ARTIST_LOADING = "GET_ARTIST_LOADING";
export const GET_ARTIST_SUCCESS = "GET_ARTIST_SUCCESS";
export const GET_ARTIST_FAILURE = "GET_ARTIST_FAILURE";

export const LOGOUT_ARTIST_LOADING = "LOGOUT_ARTIST_LOADING";
export const LOGOUT_ARTIST_SUCCESS = "LOGOUT_ARTIST_SUCCESS";
export const LOGOUT_ARTIST_FAILURE = "LOGOUT_ARTIST_FAILURE";